import { none, useState } from "@hookstate/core"
import { SetStateAction } from "react"
import { useTableData } from "./context"

export function useCell<T>(
  rowId: string,
  dataKey: keyof T,
  defaultValue?: T[keyof T],
) {
  const ctx = useTableData<T>()
  const da = useState(ctx.state.data)
  const es = useState(ctx.state.errors.nested(rowId))

  const x = da.nested(rowId).ornull?.nested(dataKey as keyof T)
  const e = es.ornull?.nested(dataKey as string).ornull

  const setValue = (value: SetStateAction<T[keyof T]>) => {
    x?.set(value)
    e?.set(none)
  }

  const value = x?.value ?? defaultValue
  const error = e?.value

  return [value, setValue, error] as const
}
